/* eslint-disable no-restricted-globals */
import _ from 'lodash'

const env = {
  // From .env
  NX_B2C_AUTHORITY: process.env.NX_B2C_AUTHORITY || process.env.NX?.NX_B2C_AUTHORITY,
  NX_B2C_SIGNIN_POLICY: process.env.NX_B2C_SIGNIN_POLICY || process.env.NX?.NX_B2C_SIGNIN_POLICY,
  NX_B2C_RESET_PASSWORD_POLICY: process.env.NX_B2C_RESET_PASSWORD_POLICY || process.env.NX?.NX_B2C_RESET_PASSWORD_POLICY,
  NX_B2C_EDIT_PROFILE_POLICY: process.env.NX_B2C_EDIT_PROFILE_POLICY || process.env.NX?.NX_B2C_EDIT_PROFILE_POLICY,
  NX_CLIENT_ID: process.env.NX_CLIENT_ID || process.env.NX?.NX_CLIENT_ID,
  NX_SCOPES: process.env.NX_SCOPES || process.env.NX?.NX_SCOPES,
  NX_API_URL: process.env.NX_API_URL || process.env.NX?.NX_API_URL,
}

window.env = env

/**
 * @type {import("@azure/msal-browser").Configuration}
 */
export const config = {
  auth: {
    authority:
      env.NX_B2C_AUTHORITY + '/' + env.NX_B2C_SIGNIN_POLICY,
    knownAuthorities: [env.NX_B2C_AUTHORITY],
    clientId: env.NX_CLIENT_ID,
    redirectUri: location.origin + '/signin-oidc',
    navigateToLoginRequestUrl: true,
    postLogoutRedirectUri: location.origin + '/'
  },
  cache: {
    cacheLocation: 'sessionStorage'
  },
  system: {
    allowRedirectInIframe: true,
    iframeHashTimeout: 8000

    // loggerOptions: {
    //   logLevel: 1,
    //   piiLoggingEnabled: true,
    //   loggerCallback: (level, message) => {
    //     console.log(message)
    //   }
    // }
  }
}

export const passwordResetAuthority =
  env.NX_B2C_AUTHORITY + '/' + env.NX_B2C_RESET_PASSWORD_POLICY

export const authenticationParameters = {
  scopes: _.uniq(['openid', ...env.NX_SCOPES.split(' ')])
}

export const apiURL = (env.NX_API_URL)



export const correlationHeader = 'zametek-utility-trackingcontext'
